/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Getall1Inputs */

const de__field_getall1 = /** @type {(inputs: _Field_Getall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtauswahl`)
};

/**

* @param {_Field_Getall1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_getall1 = /** @type {((inputs?: _Field_Getall1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Getall1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_getall1(inputs)
});
export { _field_getall1 as "_field_getAll" }